'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
require('backbone.stickit');
const UserModel = require('common/domain/entity/user');
const MemberModel = require('common/domain/entity/member');
const GroupAction = require('common/domain/action/group');
const GroupRoleRepository = require('common/domain/repository/group-role');
const MemberCollection = require('common/domain/collection/member');
const PagingCollection = require('common/domain/collection/paging');
const MemberAddItemEditView = require('balus/ui/view/body/group/modal/member-add/item');
const TypeaheadView = require('common/ui/view/typeahead');
const GroupMemberAddTemplate = require('balus/ui/template/body/group/modal/member-add/index.hbs');
const MemberDropdownItemTemplate = require('balus/ui/template/body/group/modal/member-dropdown-item.hbs');
const i18n = require('i18next');

// .query プロパティを使える Collection として
// PagingCollection を extend して UserCollection を作成
const UserCollection = PagingCollection.extend({
    model: UserModel,
    url: '/api/users',
    limit: 30,
    doReset: true,
    initialize: function() {
        UserCollection.__super__.initialize.call(this);
    }
});

const MemberListEditView = Mn.CollectionView.extend({
    childView: MemberAddItemEditView,
    tagName: 'ul',
    className: 'list list-bordered',
    sort: false,
    childViewEvents: {
        'change:member': 'memberChanged',
        'remove:member': 'memberRemove'
    },
    childViewOptions: function() {
        return {
            context: this.getOption('context'),
            groupRoles: this.getOption('groupRoles')
        }
    },

    onRender: function() {
        this.$('[data-toggle="tooltip"]').tooltip();
    },

    memberRemove: function(model) {
        this.trigger('remove:member', model);
    },

    memberChanged: function(){
        this.trigger('change:member');
    }
});

/**
 * グループメンバー追加用の "ユーザ検索Modal"
 *
 * render() 結果をDOM構造に追加した後に、 dropDownInit() を呼ぶ必要がある
 *
 * @type {*|Object|void}
 */
module.exports = Mn.View.extend({
    template: GroupMemberAddTemplate,
    regions: {
        memberList: '.member-list-wrapper'
    },
    childViewEvents: {
        'change:member': 'formFilled',
        'remove:member': 'memberRemove'
    },

    initialize: function() {
        this._originalMemberCollection = new MemberCollection(this.collection.map(m => m.clone()));
        _.bindAll(this, 'add');
        this.collection = new MemberCollection();
    },

    onRender: function() {
        this.$('.modal').on('shown.bs.modal', function() {
            $(this).find('input[type=text]:first').focus();
        });

        GroupRoleRepository.find(this.model).fetchRoles()
            .then(groupRoles => {
                this.showChildView('memberList', new MemberListEditView({
                    context: this.getOption('context'),
                    collection: this.collection,
                    groupRoles: groupRoles
                }));
            });

        this.listenTo(this.collection, 'change add remove', this.enable);

        if(!this._typeaheadView) {
            this.dropDownInit();
        }

        return this;
    },

    save: function() {
        return new Promise((resolve, reject) => {
            if(!this.model.isValid(true)) {
                reject();
            }

            this._originalMemberCollection.add(this.collection.toJSON());

            let j = this.model.toJSON();
            j._members = this._originalMemberCollection.chain()
                .filter(function(m) {
                    return !m.get('deleting')
                })
                .map(function(m){
                    return {
                        user: m.get('user'),
                        role: m.get('role'),
                        suspended: m.get('suspended')
                    }
                })
                .value();

            GroupAction.updateGroup({
                group: j
            })
                .then(() => {
                    resolve();
                })
        });
    },

    add: function(model) {
        const m = this.collection.where({
            user: model.id
        });
        if (m.length > 0) {
            const name = model.get('name');
            this.$('.name .alert-message').html(
                i18n.t('input.member.selected.exists', {name: name}));
            return '';
        } else {
            this.$('.name .alert-message').html('');
            let memberModel = new MemberModel({
                user: model.toJSON(),
                role: 'member'
            });

            this.collection.add(memberModel);
            this.formFilled();
            return '';
        }
    },

    formFilled: function(){
        this.trigger('formFilled');
    },

    memberRemove: function(model) {
        this.collection.remove(model);
    },

    dropDownInit: function() {
        let userCollection = new UserCollection();

        const isContainedToLists = (id) => {
            const originalMemberIds = this._originalMemberCollection.map(m => m.id);
            const memberIds = originalMemberIds.concat(this.collection.map(m => m.get('user').id));
            return _.contains(memberIds, id);
        };

        this._typeaheadView = new TypeaheadView({
            el: this.$('.search-user'),
            find: function(query) {
                let deferred = $.Deferred();
                userCollection.query = query;
                userCollection.fetch({
                    success: function(search_result) {
                        const candidate_users = search_result.reject(user => isContainedToLists(user.id));
                        deferred.resolve(candidate_users.slice(0,10));
                    }
                });

                return deferred.done;
            },
            // Dropdown が選択された時に呼ばれる
            update: this.add,
            // itemView は DropdownItemView を使って作成
            itemView: TypeaheadView.DropdownItemView.extend({
                template: MemberDropdownItemTemplate
            }),
            minLength: 1
        });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/modal/member-add/index.js